import { inject, Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class CustomDateAdapter extends MomentDateAdapter {
    private transloco = inject(TranslocoService);

    constructor() {
        // MAT_DATE_LOCALE and MAT_MOMENT_DATE_ADAPTER_OPTIONS are injected by the base class
        super();
        this.transloco.langChanges$.subscribe((lang) => this.setLocale(lang));
    }
}
